import { render, staticRenderFns } from "./RoomRecord.vue?vue&type=template&id=13490092&scoped=true&"
import script from "./RoomRecord.vue?vue&type=script&lang=js&"
export * from "./RoomRecord.vue?vue&type=script&lang=js&"
import style0 from "./RoomRecord.vue?vue&type=style&index=0&id=13490092&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13490092",
  null
  
)

export default component.exports